<template>
    <!-- 点赞 收藏 评论 分享 -->
    <div class="item-box">
        <el-dialog
            :visible.sync="addialogVisible"
            :close-on-click-modal="false"
            width="60%"
            :title="title"
            :before-close="close"
        >
            <div class="infor-item">
                <sc-table-v2
                    v-if="addialogVisible"
                    :head="title == '评论' ? comTableHead : tableHead"
                    :data="list"
                    :page="page"
                    :page-hide="false"
                    :read-table="true"
                    :load="load"
                    :pop-show="false"
                    :show-add="false"
                    :table-height="tableHeightCalc"
                    :selection="false"
                    ref="refTable"
                    @pageChange="pageChange"
                    @pageSizesChange="pageSizesChange"
                ></sc-table-v2>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getUserAction } from '@/api/mkt/user.js';

export default {
    name: 'browse-list',
    props: {
        title: {
            type: String,
            default: '',
        },
    },
    watch: {
        title: {
            immediate: true,
            handler(newVal) {
                if (newVal == '点赞' || newVal == '收藏' || newVal == '评论' || newVal == '分享') {
                    let obj = {
                        点赞: 1,
                        收藏: 2,
                        评论: 3,
                        分享: 4,
                    };
                    this.type = obj[newVal];
                    this.getUserAction();
                }
            },
        },
    },
    data() {
        return {
            load: false,
            addialogVisible: false,
            tableHead: [
                { name: '互动时间', key: 'createTime' },
                { name: '内容类型', key: 'contentTypes' },
                { name: '互动内容', key: 'contentName' },
            ],
            comTableHead: [
                { name: '互动时间', key: 'createTime' },
                { name: '内容类型', key: 'contentTypes' },
                { name: '互动内容', key: 'contentName' },
                { name: '评论内容', key: 'content' },
            ],
            tableHeightCalc: window.innerHeight - 420,
            page: {
                size: 30,
                page: 1,
                count: 0,
            },
            list: [],
            type: '',
        };
    },
    methods: {
        getUserAction() {
            this.load = true;
            getUserAction({
                accountId: this.$route.query.accountId,
                page: this.page.page,
                size: this.page.size,
                type: this.type,
            }).then(res => {
                if (res.code == 200) {
                    this.load = false;
                    let obj = {
                        1: '笔记',
                        2: '案例',
                        3: '灵感集',
                        4: '话题',
                        8: '作品图',
                        10: '切片',
                        11: '设计师主页',
                    };
                    res.data.children.forEach(ele => {
                        ele.contentTypes = obj[ele.contentType];
                    });
                    this.list = res.data.children;
                    this.page.count = res.data.total;
                }
            });
        },
        open(row) {
            this.addialogVisible = true;
        },
        close() {
            this.addialogVisible = false;
        },
        pageChange(val) {
            this.page.page = val;
            this.getUserAction();
            this.$nextTick(() => {
                this.$refs.refTable.$refs['table-box'].bodyWrapper.scrollTop = 0;
            });
        },
        pageSizesChange(val) {
            this.page.size = val;
            this.getUserAction();
        },
    },
};
</script>

<style lang="less" scoped>
.item-box {
    margin-bottom: 20px;
    /deep/ .el-dialog__body {
        padding: 10px 20px !important;
    }
    .top-line {
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d7d7d7;
        line-height: 34px;
        .tit {
            color: #d9001b;
        }
    }
    .infor-item {
    }
}
</style>
